import { createStyles, makeStyles } from '@material-ui/core';
import { FONT_FAMILY } from '../../../constants';

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      display: 'flex',
      width: '30%',
    },
    mobileWrapper: {
      display: 'flex',
      width: '50%',
    },
    dropDown: {
      height: '20px',
      width: '20px',
      marginTop: '5px',
    },
    headingStyle: {
      fontFamily: FONT_FAMILY,
      fontWeight: 'bold',
      marginTop: '2%',
    },
    headingStyleMobile: {
      fontFamily: FONT_FAMILY,
      fontWeight: 'bold',
      marginTop: '2%',
      fontSize: '13px',
    },
    filterText: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '1%',
      marginRight: '2%',
    },

    filterTextMobile: {
      marginTop: '2%',
      marginLeft: '1%',
      display: 'flex',
    },
    filterIcon: {
      height: '20px',
      width: '20px',
      marginLeft: '5px',
      paddingTop: '4px',
    },
    filterIconMobile: {
      display: 'none',
    },
    dropDownImgClass: {
      width: '15px',
      height: '15px',
    },
    textOpera: {
      color: 'grey',
      fontSize: '11px',
      marginTop: '1.3%',
      marginRight: '2.5%',
    },
    mobileTextLabel: {
      lineHeight: '10px',
      fontSize: '0.8rem',
    },
    textLabel: {
      fontSize: '0.8rem',
    },

    checkboxWrapperMobile: {
      display: 'none',
    },
    checkboxWrapper: {
      marginTop: '1%',
    },
  })
);



// WEBPACK FOOTER //
// ./src/Pages/HomePage/OptionTradeFilterBar/index.styles.js